(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class BackInStockComponent extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-back-in-stock-dialog]');
      this.form = this.querySelector('[data-back-in-stock-form]');
      this.status = this.querySelector('[data-back-in-stock-status]');
      this.submitButton = this.querySelector('.cds-back-in-stock__submit');
      this.submitText = this.querySelector('[data-back-in-stock-submit-text]');
      this.defaultSubmitText = this.submitText?.textContent || '';
      this.productForm = this.parentElement?.querySelector('product-form-component');
      this.section = this.closest('.shopify-section');

      this.querySelector('[data-back-in-stock-open]')?.addEventListener('click', this.openDialog);
      this.querySelector('[data-back-in-stock-close]')?.addEventListener('click', this.closeDialog);
      this.dialog?.addEventListener('click', this.closeOnBackdrop);
      this.form?.addEventListener('submit', this.submitRequest);
      this.section?.addEventListener('variant:update', this.handleVariantUpdate);

      this.style.display = this.hidden ? 'none' : '';
      if (!this.hidden && this.productForm) {
        this.productForm.setAttribute('hidden', '');
        this.productForm.style.display = 'none';
      }
    }

    disconnectedCallback() {
      this.querySelector('[data-back-in-stock-open]')?.removeEventListener('click', this.openDialog);
      this.querySelector('[data-back-in-stock-close]')?.removeEventListener('click', this.closeDialog);
      this.dialog?.removeEventListener('click', this.closeOnBackdrop);
      this.form?.removeEventListener('submit', this.submitRequest);
      this.section?.removeEventListener('variant:update', this.handleVariantUpdate);
    }

    openDialog = () => {
      this.status.textContent = '';
      this.dialog?.showModal();
    };

    closeDialog = () => {
      this.dialog?.close();
    };

    closeOnBackdrop = (event) => {
      if (event.target === this.dialog) this.closeDialog();
    };

    handleVariantUpdate = (event) => {
      const eventProductId = event.detail?.data?.newProduct?.id || event.detail?.data?.productId;
      if (eventProductId && String(eventProductId) !== this.dataset.productId) return;

      const variant = event.detail?.resource;
      const isAvailable = Boolean(variant?.available);

      if (variant) {
        this.dataset.variantId = variant.id || '';
        this.dataset.variantTitle = variant.title || '';
        this.dataset.variantSku = variant.sku || '';
      }

      this.hidden = isAvailable;
      this.style.display = isAvailable ? 'none' : '';
      this.parentElement?.classList.toggle('buy-buttons-block--unavailable', !isAvailable);
      this.productForm?.toggleAttribute('hidden', !isAvailable);
      if (this.productForm) this.productForm.style.display = isAvailable ? '' : 'none';
      if (isAvailable) this.dialog?.close();
    };

    submitRequest = async (event) => {
      event.preventDefault();
      if (!this.form?.reportValidity()) return;

      const email = new FormData(this.form).get('email');
      this.submitButton.disabled = true;
      this.submitText.textContent = this.dataset.loadingText;
      this.status.textContent = '';

      const payload = {
        event: 'back_in_stock_request',
        email,
        product: {
          id: this.dataset.productId,
          title: this.dataset.productTitle,
          handle: this.dataset.productHandle,
          url: window.location.href,
        },
        variant: {
          id: this.dataset.variantId,
          title: this.dataset.variantTitle,
          sku: this.dataset.variantSku,
        },
        requested_at: new Date().toISOString(),
      };

      try {
        const response = await fetch(this.dataset.webhookUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) throw new Error('Webhook request failed');
        this.status.textContent = this.dataset.successText;
        this.form.reset();
      } catch (error) {
        this.status.textContent = this.dataset.errorText;
      } finally {
        this.submitButton.disabled = false;
        this.submitText.textContent = this.defaultSubmitText;
      }
    };
  }

  if (!customElements.get('back-in-stock-component')) {
    customElements.define('back-in-stock-component', BackInStockComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-brand-code"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-brand-code')) {
    class ProductBrandCode extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.closest('.shopify-section, dialog')?.addEventListener('variant:update', this.handleVariantUpdate, {
          signal: this.abortController.signal,
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      handleVariantUpdate = (event) => {
        const productId = event.detail?.data?.productId;
        if (!event.detail?.data?.newProduct && productId !== this.dataset.productId) return;

        const code = this.querySelector('[data-product-code]');
        const sku = this.querySelector('[data-product-sku]');
        if (!code || !sku) return;

        const nextSku = event.detail?.resource?.sku ?? '';
        sku.textContent = nextSku;
        code.hidden = nextSku === '';
      };
    }

    customElements.define('product-brand-code', ProductBrandCode);
  }
  } catch(e) { console.error(e); }
})();

})();
